import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { Progressbar } from '../../../../AbstractElements';
import { BasicProgressBars, BasicProgressBarsPara } from '../../../../Constant';
import HeaderCard from '../../../Common/HeaderCard';

const Basic = () => {
  return (
    <Card>
      <HeaderCard title={BasicProgressBars} span1={BasicProgressBarsPara} />
      <CardBody className='card-body progress-showcase row'>
        <Col>
          <Progressbar value='0' />
          <Progressbar color='primary' value='25' />
          <Progressbar color='secondary' value='50' />
          <Progressbar color='success' value='75' />
          <Progressbar color='info' value='100' />
        </Col>
      </CardBody>
    </Card>
  );
};

export default Basic;
